var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.994,
    height: 16.564,
    viewBox: "0 0 17.994 16.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "suitcase",
    transform: "translate(0 -31)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31407",
    "data-name": "Path 31407",
    d: "M227.581,259.163a.527.527,0,0,0,.527-.527v-2.109a.527.527,0,0,0-.527-.527h-1.054a.527.527,0,0,0-.527.527v2.109a.527.527,0,0,0,.527.527Z",
    transform: "translate(-218.058 -216.753)",
    fill: "#072430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31408",
    "data-name": "Path 31408",
    d: "M16.412,33.109H12.687v-.527A1.583,1.583,0,0,0,11.105,31H6.888a1.583,1.583,0,0,0-1.581,1.581v.527H1.581A1.583,1.583,0,0,0,0,34.69,8.759,8.759,0,0,0,.378,37.4,4.7,4.7,0,0,0,1.5,39.3a4.219,4.219,0,0,0,3.109,1.186H6.888V39.434A1.583,1.583,0,0,1,8.47,37.853H9.524a1.583,1.583,0,0,1,1.581,1.581v1.054h1.171c1.049-.044,2.766.275,4.213-1.164a4.681,4.681,0,0,0,1.126-1.909,8.855,8.855,0,0,0,.378-2.725A1.583,1.583,0,0,0,16.412,33.109ZM6.361,32.581a.528.528,0,0,1,.527-.527h4.217a.528.528,0,0,1,.527.527v.527H6.361Z",
    transform: "translate(0 0)",
    fill: "#072430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31409",
    "data-name": "Path 31409",
    d: "M12.291,263.291H11.105a1.583,1.583,0,0,1-1.581,1.581H8.47a1.583,1.583,0,0,1-1.581-1.581H4.618A5.251,5.251,0,0,1,.759,261.8,5.292,5.292,0,0,1,0,260.825v7.211a.527.527,0,0,0,.527.527H17.466a.527.527,0,0,0,.527-.527v-7.189a5.251,5.251,0,0,1-.76.973C15.57,263.475,13.8,263.22,12.291,263.291Z",
    transform: "translate(0 -220.998)",
    fill: "#072430"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.3b2af8ad60b46932b0f71b552ab70abd.svg";
export { ForwardRef as ReactComponent };